import { GridDetail } from '../types'
import { GridRepository, GridWithoutPaginationRepository } from './GridRepository'

import { makeUseList } from '@elentari/core'

export const useGridsList = makeUseList<GridDetail>(GridRepository.fetch)

export const useGridsListWithoutPagination = makeUseList<GridDetail>(GridWithoutPaginationRepository.fetch)